import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

type FabProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  icon: ReactNode;
};

export const Fab = forwardRef<HTMLButtonElement, FabProps>(function Fab(
  { label, icon, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      className={cn(
        'fixed bottom-24 right-4 z-30 inline-flex h-14 w-14 items-center justify-center',
        'rounded-full bg-brand-600 text-white shadow-elev',
        'hover:bg-brand-700 active:bg-brand-800',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40',
        'cursor-pointer disabled:cursor-not-allowed disabled:opacity-80',
        'md:bottom-6 md:right-6',
        className,
      )}
      style={{ bottom: 'calc(env(safe-area-inset-bottom) + 6rem)' }}
      {...rest}
    >
      {icon}
    </button>
  );
});
